import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "diagnosis-table-container" }
const _hoisted_2 = { key: "action" }
const _hoisted_3 = {
  class: "pdx",
  key: "pdx"
}
const _hoisted_4 = { key: "drgModifier" }
const _hoisted_5 = {
  key: "code",
  class: "code"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: "description",
  class: "text-ellipsis"
}
const _hoisted_8 = { key: "poa" }
const _hoisted_9 = { key: "quality" }
const _hoisted_10 = { key: "risk" }

import { QTableProps } from 'quasar';
import DataTable from 'components/global-common/DataTable.vue';
import { useDiagnosisStore } from 'stores/DiagnosisStore';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosisPane',
  setup(__props) {

const columns: QTableProps['columns'] = [
  {name: 'action', align: 'center', label: '', field: 'action', sortable: false},
  {name: 'pdx', align: 'center', label: '', field: 'pdx', sortable: false},
  {name: 'drgModifier', align: 'center', label: 'DRG Modifier', field: 'drgModifier', sortable: false},
  {name: 'code', align: 'left', label: 'Code', field: 'code', sortable: false},
  {name: 'description', align: 'left', label: 'Diagnosis Description', field: 'description', sortable: false},
  {name: 'poa', align: 'center', label: 'POA', field: 'poa', sortable: false},
  {name: 'quality', align: 'center', label: 'Quality', field: 'quality', sortable: false},
  {name: 'risk', align: 'center', label: 'Risk', field: 'risk', sortable: false}
];

const rows = useDiagnosisStore().diagnosisData;
const text = ref('');

function addRow(code: string) {
  console.log('Add row placeholder.');
  rows?.push({ id: 10, action: '', pdx: [], drgModifier: [], code, description: 'test', poa: '', quality: [], risk: [] })
}

function setPoa() {
  console.log('Set POA placeholder.');
}


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DataTable, {
      title: "Diagnosis(9)",
      rows: _unref(rows)
    }, {
      "dt-header-top-right": _withCtx(() => [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          dense: "",
          flat: "",
          rounded: "",
          class: "poa",
          onClick: setPoa
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Set POAs to Y ")
          ]),
          _: 1
        })
      ]),
      "dt-thead": _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
              return _createElementVNode("th", {
                key: col.name
              }, _toDisplayString(col.label), 1)
            }), 64))
          ])
        ])
      ]),
      "dt-rows": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (row) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: _normalizeClass((row.id % 2 === 1)?'iodine-alternate-table-row':'bg-white text-black')
          }, [
            _createElementVNode("td", _hoisted_2, [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                dense: "",
                flat: "",
                round: "",
                class: "text-none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: "fa-solid fa-ellipsis-vertical",
                    size: "16px"
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("td", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.pdx, (pdx, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(pdx)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(pdx), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.drgModifier, (drgModifier, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(drgModifier)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(drgModifier), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_5, [
              (row.code === '')
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 0,
                    dense: "",
                    outlined: "",
                    modelValue: text.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
                    placeholder: "Add Code",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (addRow(text.value)))
                  }, {
                    append: _withCtx(() => [
                      (text.value === '')
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-solid fa-circle-plus"
                          }))
                        : (_openBlock(), _createBlock(_component_q_icon, {
                            key: 1,
                            name: "fa-regular fa-circle-xmark",
                            class: "cursor-pointer"
                          }))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(row.code), 1))
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.description), 1)
                ]),
                _: 2
              }, 1024),
              _createTextVNode(" " + _toDisplayString(row.description), 1)
            ]),
            _createElementVNode("td", _hoisted_8, _toDisplayString(row.poa), 1),
            _createElementVNode("td", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.quality, (quality, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(quality)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(quality), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.risk, (risk, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(risk)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(risk), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ])
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["rows"])
  ]))
}
}

})